import {
	convertToNumber,
	findSequenceLineNumber,
	getAttrDataClass,
	getAttrDataId,
	getAttrDataSegment,
	getElementsByClasses,
} from "./common";

export const FEATURE_SEGMENT_ANY = 9999;

// select all DOM elements with the same class name, feature id and segmentIndex.  If
// the segement index or line number is -1, then ignore it.
export const queryFeatureElements = (
	parentElement,
	classNames,
	featureId,
	segmentIndex,
	lineNumber,
) => {
	const FEATURE_ID = convertToNumber(featureId);
	const SEGMENT_INDEX = convertToNumber(segmentIndex);
	const LINE_NUMBER = convertToNumber(lineNumber);
	// console.log(parentElement, classNames, FEATURE_ID, SEGMENT_INDEX, lineNumber);
	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	const parentElements = parentElement.parentElement;
	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElements.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let missingClass = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				missingClass = true;
				break;
			}
		}
		if (missingClass) continue;

		// check for feature id match
		if (FEATURE_ID !== -1) {
			const id = getAttrDataId(e);
			if (id !== FEATURE_ID) continue;
		}

		// check for segment match
		if (SEGMENT_INDEX !== FEATURE_SEGMENT_ANY) {
			const segment = getAttrDataSegment(e);
			if (segment !== SEGMENT_INDEX) continue;
		}

		// check for line match
		if (LINE_NUMBER !== -1) {
			const line = findSequenceLineNumber(e);
			if (line !== LINE_NUMBER) continue;
		}

		ret.push(e);
	}
	return ret;
};
